if($('.week-ending').length > 0){
    $('.page-nav .nav-item a.nav-link').on('shown.bs.tab', function(event){
        let date = $(event.target).data('week-end');

        let weekIndex = $(event.target).data('week-index');

        $('.week-ending').html(date);
        $('.week-index').html(weekIndex);

        setUrl(weekIndex);
    });

    let weekEnd = $('.page-nav .nav-item a.nav-link.active').data('week-end');
    $('.week-ending').html(weekEnd != undefined ? weekEnd : '');

    let weekIndex = $('.page-nav .nav-item a.nav-link.active').data('week-index');
    $('.week-index').html(weekIndex != undefined ? weekIndex : 1);

    setUrl(weekIndex != undefined ? weekIndex : 1);

    function setUrl(weekIndex) {
        //set url so exporting works properly
        let parts = window.location.href.split('breakdown');

        //find where url parameters start
        let start = parts[1].indexOf('?');

        //slice used to get parameters if they exist
        let extra = parts[1].slice(start == -1 ? parts[1].length : start);

        //set the url to the build url
        window.history.pushState(
            '',
            '',
            parts[0] + `breakdown/${weekIndex}${extra}`
        );

        $('#pdf_export_button').attr(
            'href',
            $('#pdf_export_button').attr('href').split('breakdown/pdf')[0] + `breakdown/pdf/${weekIndex}${extra}`
        );
    }
}

